import { styled } from "styled-components";

export const Container = styled.div`
  max-width: 800px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 17px;
  max-width: 900px;
`;

export const FormGroup = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 50px;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #333;
  width: 175px;
  padding-top: 10px;
`;

export const DeleteButton = styled.button`
  color: ${props => props.theme.colors.danger};
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 10px 0;
  
  &:hover {
    text-decoration: underline;
  }
`;
